import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { updateSection } from "../../../../../features/assignment/assignmentSlice";

import { getContentHeight } from "../../../../../utils/textUtils";
import { getStartingIndex } from "../../../../../utils/resumeUtils";

import SentenceReorder from "./SentenceReorder";
import CorrectOverlay from "../../widgets/CorrectOverlay";
import ArrowButton from "../../widgets/ArrowButton";

const FlowPage = ({ setCurrentStep, isPreview, isReview }) => {
  const dispatch = useDispatch();

  const { section } = useSelector((state) => state.assignment);

  const [pageList, setPageList] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isIncorrectOverlayVisible, setIsIncorrectOverlayVisible] =
    useState(false);

  const currentPage = pageList[currentIndex] || {
    type: "",
    data: {
      question_text: "",
      question: [],
      answer: [],
      input: [],
    },
  };

  useEffect(() => {
    if (pageList.length > 0) return;

    if (!isPreview && section.answer.length > 0) {
      setPageList(section.answer);
      setCurrentIndex(getStartingIndex(section.resumeIndex));
      return;
    }

    const tempPageList = [];
    const typeData = section.question.type_data;

    if (typeData) {
      if (typeData.kor) {
        const answer = section.question.data
          .slice(1)
          .map((sentence) => sentence[1]);
        tempPageList.push({
          type: "flow",
          data: {
            question_text: section.question.data[0][1],
            question: answer.slice().sort(() => Math.random() - 0.5),
            answer: answer,
            input: [],
          },
          isSubmitted: false,
        });
      }
      if (typeData.eng) {
        const answer = section.question.data
          .slice(1)
          .map((sentence) => sentence[0]);
        tempPageList.push({
          type: "flow",
          data: {
            question_text: section.question.data[0][0],
            question: answer.slice().sort(() => Math.random() - 0.5),
            answer: answer,
            input: [],
          },
          isSubmitted: false,
        });
      }
    } else {
      for (let i = 0; i < 2; i++) {
        const answer = section.question.data
          .slice(1)
          .map((sentence) => sentence[i ^ 1]);
        tempPageList.push({
          type: "flow",
          data: {
            question_text: section.question.data[0][i ^ 1],
            question: answer.slice().sort(() => Math.random() - 0.5),
            answer: answer,
            input: [],
          },
          isSubmitted: false,
        });
      }
    }
    setPageList(tempPageList);
  }, [section]);

  const handleNext = async () => {
    if (currentIndex === 0) {
      setCurrentIndex(1);
      setIsIncorrectOverlayVisible(false);
    } else if (currentIndex === 1) {
      if (!isPreview && !isReview) {
        dispatch(
          updateSection({
            sectionId: section.id,
            data: { is_finished: true, answer: pageList },
          })
        );
      }
      alert("학습이 완료되었습니다.");
      setCurrentStep(2);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        height: getContentHeight(),
        fontFamily: '"Noto Sans KR", sans-serif',
        backgroundColor: "#FFFFFF",
      }}
    >
      {currentPage.type === "flow" && (
        <>
          <div
            style={{
              opacity: isIncorrectOverlayVisible ? 1 : 0, // Fade-in/out
              visibility: isIncorrectOverlayVisible ? "visible" : "hidden", // DOM에서 숨김
              transition: "opacity 200ms ease-out, visibility 200ms",
            }}
          >
            <CorrectOverlay bool={currentPage.isSubmitted} />
          </div>
          <SentenceReorder
            currentPage={currentPage}
            currentIndex={currentIndex}
            pageList={pageList}
            section={section}
            setPageList={setPageList}
            setIsIncorrectOverlayVisible={setIsIncorrectOverlayVisible}
          />
        </>
      )}
      {/* 화살표 버튼 (화면 오른쪽 중앙 고정) */}
      <div
        style={{
          position: "fixed", // 화면 자체에 고정
          right: "60px", // 우측 여백
          top: "50%", // 수직 중앙
          transform: "translateY(-50%)",
          border: "none",
          backgroundColor: "#FFF",
          color: "#BEBEBE",
          cursor: "pointer",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "15px", // 버튼 여백 (원하는 대로 조정)
        }}
      >
        <ArrowButton
          direction="right"
          onClick={() => handleNext()}
          visibleCondition={currentPage.isSubmitted === true}
        />
      </div>
    </div>
  );
};

export default FlowPage;
